<div class="main-slider__container">
  <div class="main-slider">
    <div class="main-slider__mask">
      <div class="main-slider__mask-inner"></div>
    </div>

    <div class="main-slider__imgs">
      <div class="main-slider__item" #bannerSlider *ngFor="let banner of banners">
        <img [src]="banner.bannerUrl" />
      </div>
    </div>

    <div class="main-slider__contents">
      <div class="main-slider__item" *ngFor="let banner of banners">
        <div class="main-slider__content">
          <div class="main-slider__song">{{ banner.title }}</div>
          <div class="main-slider__artist">{{ getSongName(banner) }}</div>
          <div class="main-slider__button">
            <div class="button button_size_l" (click)="redirect(banner.url)">{{ 'main-page-banner.add-service' | translate }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
